<template>
  <v-form @submit.prevent="validate()" class="loginform">
    <!-- <v-card-title class="headline">Fazer login</v-card-title> -->

    <v-card-text class="pb-0">
      <!-- Faça login com seu email e senha -->
      <v-container>
        <v-row v-if="!getEmailChecked" class="email-row">
          <v-col cols="12" class="text-center">
            <h3>Login</h3>
            <p class="mt-2">Use o mesmo email de sua pré-inscrição</p>
          </v-col>
          <!-- email input -->
          <v-col cols="12" class="pa-0 mb-5">
            <v-text-field
              v-model="email"
              outlined
              hide-details="auto"
              color="green lighten-2"
              type="email"
              label="Email"
              @keydown.enter.prevent
            />
          </v-col>

          <v-col cols="12" class="mt-0 px-0">
            <v-btn x-large block depressed class="btn-primary px-12" dark @click.stop="checkEmail()">
              Prosseguir
            </v-btn>
          </v-col>
        </v-row>
        <!-- Não cadastrou a senha -->
        <v-row v-if="getEmailChecked === 1" class="justify-center">
          <!-- <p>1</p> -->
          <p class="text-center">Escolha uma senha para acessar a plataforma</p>
          <v-col cols="12" class="pa-0 mb-5">
            <v-text-field
              v-model="password"
              outlined
              color="green lighten-2"
              label="Senha"
              :rules="rules"
              hide-details="auto"
              hint="Sua senha deve conter no mínimo 6 caracteres"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            />
          </v-col>
          <v-col cols="12" class="pa-0 mb-5">
            <v-text-field
              v-model="confirmPassword"
              outlined
              color="green lighten-2"
              label="Confirmar Senha"
              :rules="rules"
              hide-details="auto"
              hint="Deve ser igual ao campo 'Senha'"
              :type="showConfirmPassword ? 'text' : 'password'"
              :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showConfirmPassword = !showConfirmPassword"
            />
          </v-col>
          <v-col cols="6" class="px-1">
            <v-btn x-large block depressed text class="" color="green" dark @click.stop="setEmailChecked(false)">
              voltar
            </v-btn>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-btn x-large block depressed class="btn-primary" dark @click="createUser()">
              Entrar
            </v-btn>
          </v-col>
        </v-row>
        <!-- {{getEmailChecked}} -->
        <!-- Já cadastrou a senha -->
        <v-row v-if="getEmailChecked === 2" class="justify-center">
          <!-- <p>2</p> -->
          <p>Digite sua Senha</p>
          <v-col cols="12" class="pa-0">
            <v-text-field
              v-model="password"
              outlined
              color="green lighten-2"
              label="Senha"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            />
          </v-col>
          <v-col cols="6" class="px-1">
            <v-btn x-large block depressed text class="" color="green" dark @click.stop="setEmailChecked(false)">
              voltar
            </v-btn>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-btn x-large block depressed class="btn-primary " dark type="submit">
              Entrar
            </v-btn>
          </v-col>
          <v-col cols="12" class="text-center">
            <p>
              <a
                class="font-weight-bold underline"
                @click.prevent="retrieve()"
              >
                Esqueceu sua senha?
              </a>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <div class="justify-center px-8">
      <v-row>
        <!-- <v-btn x-large block depressed class="btn-primary px-12" dark type="submit">
          Entrar
        </v-btn> -->

      </v-row>
      <!-- <v-row v-if="!getEmailChecked" class="justify-center register-div">
        <v-col cols="12" class="mt-4 px-10">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" class="text-center">
          <p>Ainda não fez sua inscrição?</p>
          <v-btn text x-large block class="btn-primary--text px-6" href="/pre-inscricao">
            Criar conta
          </v-btn>
        </v-col>
      </v-row> -->

      <!-- <v-spacer></v-spacer> -->

    </div>
  </v-form>
</template>

<script>
// import db from '@/firebase/init'
// import firebase from 'firebase'
import {mapActions, mapGetters, mapMutations} from "vuex"
export default {
  name: 'LoginForm',
  data() {
    return {
      email: null,
      password: null,
      confirmPassword: null,
      showConfirmPassword: false,
      showPassword: false,
      rules: [
        value => !!value || 'Campo obrigatório',
        value => (value && value.length >= 6) || 'Mínimo 6 characters',
      ],
      newUsers: [
        // "jhtristao1@gmail.com",
        // "melcorbellini@yahoo.com.br",
        // "mvitoria.quintero@gmail.com",
        // "floramarcolino@ul.com.br",
        // "bruno_gj3@yahoo.com.br",
        // "robertageriatra@gmail.com",
        // "marielyfernanda@gmail.com",
        // "nattymedfaria@gmail.com",
        // "martins.sandraregina@hotmail.com",
        // "crislazarski@gmail.com",
        // "aboomsbot@gmail.com",
        // "lucasrpdo@gmail.com",
        // "kellyarau@gmail.com",
        // "baishengbrazil@gmail.com",
        // "deiadiedrichs@gmail.com",
        // "tesedocsales@gmail.com",
        // "escosrib@fmail.com",
        // "michellecrangel@gmail.com",
        // "lucas.tb94@hotmail.com",
        // "marconealexandrino@gmail.com",
        // "alinecardozo43@hotmail.com",
        // "am.braga@terra.com.br",
        // "aledebbo@hotmail.com",
        // "mary.rabi@gmail.com",
        // "chrispimangel@superig.com.br",
        // "paula_leite@me.com",
        // "nanatoazevedo@hotmail.com",
        // "brenopacheco7@gmail.com",
        // "danielmerenlender@gmail.com",
      ],
    }
  },
  computed: {
    ...mapGetters(['getUser', 'isUserAuth', 'getEmailChecked', 'getLoadingPage'])
  },
  methods: {
    ...mapActions(['signUpAction', 'loginAction', 'checkEmailAction', 'retrieveAction']),
    ...mapMutations(['toggleLogin', 'toggleRegister', 'toggleForgot', 'openFeedbackModal', 'setFeedback', 'setEmailChecked']),

    checkEmail() {
      if(this.email){
        // console.log('login: ' + this.email)
        this.checkEmailAction({ email: this.email })
        // console.log('entrou')
      } else{
        this.setFeedback({
          show: true,
          message: 'Preencha o campo email',
          btnTxt: 'OK',
          color: 'yellow darken-1',
          textColor: 'black--text'
        })
      }

    },

    validate() {
      if(this.email && this.password){
        // console.log('login: ' + this.email + ' ' + this.password)
        this.login()
      } else{
        this.setFeedback({
          show: true,
          message: 'Todos os campos devem ser preenchidos',
          btnTxt: 'OK',
          color: 'amber',
          textColor: 'black--text'
        })
      }
    },
    login(){
      this
        .loginAction({
          email: this.email,
          password: this.password
        })
        .then(this.resetForm(), this.setEmailChecked(false))
    },
    resetForm() {
      this.email = null
      this.password = null
      this.confirmPassword = null
    },
    retrieve(){
      this.email ?
      this.retrieveAction({email: this.email}) :
      this.setFeedback({
        show: true,
        message: 'Preencha o campo email',
        btnTxt: 'OK',
        color: 'amber',
        textColor: 'black--text'
      })
    },
    createUser() {
      if (!this.password && !this.confirmPassword) {
        this.setFeedback({
          show: true,
          message: 'Preencha todos os campos',
          btnTxt: 'OK',
          color: 'amber',
          textColor: 'black--text'
        })
      } else if (this.password != this.confirmPassword) {
        this.setFeedback({
          show: true,
          message: 'Os campos "Senha" e "Confirmar Senha" devem ser iguais',
          btnTxt: 'OK',
          color: 'amber',
          textColor: 'black--text'
        })
        // console.log('devem ser iguais')
      } else {
        this
        .signUpAction({
          email: this.email,
          password: this.password
        })
        .then(this.resetForm())
      }
    }
  },
  mounted() {
    // let count = 0
    // this.newUsers.forEach(user => {
    //   console.log(count)
    //   console.log(user)
    //   db.collection('pre-insc2')
    //     .doc(user)
    //     .set({
    //       email: user,
    //       checked: false,
    //     })
    //     .then(() => {
    //       console.log(count)
    //       count++
    //     })
    // });
  },
}
</script>

<style lang="scss">
@import '@/variables/style.scss';

.loginform {

  // .register-div {
    h3 {
      text-transform: uppercase;
      letter-spacing: 2px;
    }
    p {
      text-transform: uppercase;
      letter-spacing: 2px;
      font-size: .6rem;

      a {
        color: #101010;
        transition: .2s;

        &:hover {
          color: #FFFFFF;
          background-color: $primary;
          // padding-bottom: 2px;
          border-bottom: none;
        }
      }
    }
  // }
}
</style>